import { i as t, a as e, s } from "../checks-C6AyTTQ0.js";
const a = r => t(r) ? Array.isArray(r) ? e(r) : typeof r == "string" ? s(r) : !0 : !1;
export { a as isBlockContentValuePresent };